var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-6" },
    [
      _c("h2", { staticClass: "text-xl font-semibold mb-4" }, [
        _vm._v("Gestión de Usuarios"),
      ]),
      _c(
        "div",
        { staticClass: "dis-div" },
        [
          _c(
            "v-row",
            { attrs: { justify: "end" } },
            [
              _c("v-text-field", {
                staticClass: "r-search",
                attrs: {
                  "append-icon": "mdi-magnify",
                  "hide-details": "",
                  label: "Buscar Usuario",
                  "single-line": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1 mt-5",
        attrs: {
          headers: _vm.headers,
          items: _vm.users,
          search: _vm.search,
          loading: _vm.loading,
          "loading-text": "Cargando Usuarios...",
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.role`,
              fn: function ({ item }) {
                return _vm._l(item.role, function (r) {
                  return _c(
                    "v-chip",
                    {
                      key: r,
                      staticClass: "ma-1",
                      attrs: { color: "gray", small: "" },
                    },
                    [_vm._v(" " + _vm._s(r) + " ")]
                  )
                })
              },
            },
            {
              key: `item.permissions`,
              fn: function ({ item }) {
                return [
                  _c("v-dialog", {
                    attrs: {
                      "max-width": "1000",
                      transition: "dialog-bottom-transition",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "white--text border-button mr-2",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { color: "rgb(204 33 40)" },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(" Ver Permisos "),
                                  _c("v-icon", { staticClass: "ml-2" }, [
                                    _vm._v("mdi mdi-server-security"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (dialog) {
                            return [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      staticStyle: {
                                        "background-color": "rgb(204 33 40)",
                                        color: "white !important",
                                      },
                                      attrs: { dark: "" },
                                    },
                                    [
                                      _vm._v(
                                        " Permisos Asociados Al Usuario [" +
                                          _vm._s(item.name) +
                                          "] "
                                      ),
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: {
                                            "margin-left": "auto !important",
                                          },
                                          on: {
                                            click: function ($event) {
                                              dialog.value = false
                                            },
                                          },
                                        },
                                        [_vm._v("mdi-close ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "permiso-cell" },
                                    _vm._l(item.permissions, function (r) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: r,
                                          staticClass: "ma-1",
                                          attrs: {
                                            color: _vm.getRandomColor(r),
                                            medium: "",
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(r) + " ")]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              },
            },
            {
              key: `item.actions`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text border-button",
                      attrs: { color: "rgb(204 33 40)" },
                      on: {
                        click: function ($event) {
                          return _vm.editUser(item)
                        },
                      },
                    },
                    [
                      _vm._v(" Gestionar "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("mdi-pencil"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "900px", persistent: "" },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _vm._v(" Editar Usuario " + _vm._s(this.form.name) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModal = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "Email del Usuario", disabled: "" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: { label: "Compañia", disabled: "" },
                    model: {
                      value: _vm.form.company,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "company", $$v)
                      },
                      expression: "form.company",
                    },
                  }),
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _vm.showAlert
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "my-4",
                                  attrs: {
                                    type: _vm.alertType,
                                    dense: "",
                                    outlined: "",
                                    border: "left",
                                    "colored-border": "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "dis-div mt-3" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ml-1", attrs: { justify: "start" } },
                        [
                          _c("p", { staticClass: "c-black" }, [
                            _vm._v("Roles Disponibles"),
                          ]),
                        ]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mr-1", attrs: { justify: "end" } },
                        [
                          _c("v-text-field", {
                            staticClass: "r-search",
                            attrs: {
                              "append-icon": "mdi-magnify",
                              "hide-details": "",
                              label: "Buscar Rol",
                              "single-line": "",
                            },
                            model: {
                              value: _vm.searchModalRole,
                              callback: function ($$v) {
                                _vm.searchModalRole = $$v
                              },
                              expression: "searchModalRole",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "rol-lista mt-3",
                      attrs: { justify: "start" },
                    },
                    _vm._l(_vm.filteredRoles, function (p) {
                      return _c(
                        "v-col",
                        {
                          key: p.name,
                          attrs: { cols: "12", sm: "6", md: "6" },
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "permiso-card",
                              attrs: { elevation: "3" },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "d-flex align-center bcard" },
                                [
                                  _c("v-checkbox", {
                                    staticStyle: { "margin-top": "inherit" },
                                    attrs: {
                                      value: p.name,
                                      "hide-details": "",
                                      color: "rgb(204 33 40)",
                                    },
                                    model: {
                                      value: _vm.selectedRoles,
                                      callback: function ($$v) {
                                        _vm.selectedRoles = $$v
                                      },
                                      expression: "selectedRoles",
                                    },
                                  }),
                                  _c("div", { staticClass: "div-b-c" }, [
                                    _c("span", [_vm._v(_vm._s(p.name))]),
                                    _c("p", { staticClass: "tam-p" }, [
                                      _vm._v(_vm._s(p.description)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  Array.isArray(_vm.removePermissionsSelectRole) &&
                  _vm.removePermissionsSelectRole.length > 0
                    ? _c(
                        "div",
                        { staticClass: "dis-div mt-3" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ml-1",
                              attrs: { justify: "start" },
                            },
                            [
                              _c("p", { staticClass: "c-black" }, [
                                _vm._v("Permisos Disponibles"),
                              ]),
                            ]
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mr-1", attrs: { justify: "end" } },
                            [
                              _c("v-text-field", {
                                staticClass: "r-search",
                                attrs: {
                                  "append-icon": "mdi-magnify",
                                  "hide-details": "",
                                  label: "Buscar Permiso",
                                  "single-line": "",
                                },
                                model: {
                                  value: _vm.searchModal,
                                  callback: function ($$v) {
                                    _vm.searchModal = $$v
                                  },
                                  expression: "searchModal",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    {
                      staticClass: "permiso-lista mt-3",
                      attrs: { justify: "start" },
                    },
                    _vm._l(_vm.removePermissionsSelectRole, function (p) {
                      return _c(
                        "v-col",
                        {
                          key: p.name,
                          attrs: { cols: "12", sm: "6", md: "6" },
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "permiso-card",
                              attrs: { elevation: "3" },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "d-flex align-center bcard" },
                                [
                                  _c("v-checkbox", {
                                    staticStyle: { "margin-top": "inherit" },
                                    attrs: {
                                      value: p.name,
                                      "hide-details": "",
                                      color: "rgb(204 33 40)",
                                    },
                                    model: {
                                      value: _vm.selectedPermissions,
                                      callback: function ($$v) {
                                        _vm.selectedPermissions = $$v
                                      },
                                      expression: "selectedPermissions",
                                    },
                                  }),
                                  _c("div", { staticClass: "div-b-c" }, [
                                    _c("span", [_vm._v(_vm._s(p.name))]),
                                    _c("p", { staticClass: "tam-p" }, [
                                      _vm._v(_vm._s(p.description)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "gray", text: "" },
                      on: { click: _vm.closeModal },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "background-color": "rgb(204 33 40)",
                        color: "white !important",
                      },
                      on: { click: _vm.saveUser },
                    },
                    [_vm._v(" Guardar Cambios ")]
                  ),
                ],
                1
              ),
              _c(
                "v-overlay",
                { attrs: { value: _vm.loading, absolute: "", opacity: "0.6" } },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: "64",
                      color: "rgb(204 33 40)",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }